import { GridSortCellParams, gridStringOrNumberComparator } from '@mui/x-data-grid'

export const complianceSortComparator = (sortDirection: string | null | undefined, a: number, b: number, cellParams1: GridSortCellParams<any>, cellParams2: GridSortCellParams<any>) => {
  const modifier = sortDirection === 'desc' ? -1 : 1
  if (a === b) return 0
  if (a === 4 || a === null) return 1
  if (b === 4 || b === null) return -1
  return (
    modifier *
    gridStringOrNumberComparator(a, b, cellParams1, cellParams2)
  )
}